import React from 'react';
import { PlayIcon } from '@heroicons/react/24/solid';
import { TUTORIAL_TOPICS } from '../utils/tutorialTopics';

function TutorialCard({ topic }) {
  return (
    <div className="bg-white dark:bg-[#111827] rounded-2xl shadow-sm border border-gray-200/60 dark:border-white/10 overflow-hidden flex flex-col group hover:shadow-lg hover:border-cerulean/30 dark:hover:border-cerulean/30 transition-all duration-300">
      {/* Video tile */}
      <div className="relative bg-gray-50 dark:bg-white/5 aspect-video flex items-center justify-center">
        <span className="text-5xl" aria-hidden="true">{topic.emoji}</span>
        {topic.videoUrl ? (
          <button
            type="button"
            className="absolute inset-0 flex items-center justify-center bg-black/0 hover:bg-black/10 transition-colors"
            aria-label={`Play video: ${topic.title}`}
          >
            <span className="w-12 h-12 rounded-full bg-white/90 shadow-lg flex items-center justify-center group-hover:scale-105 transition-transform">
              <PlayIcon className="w-5 h-5 text-cerulean ml-0.5" />
            </span>
          </button>
        ) : (
          <span className="absolute bottom-2 right-2 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-gray-900/70 text-white">
            Coming soon
          </span>
        )}
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col flex-1">
        <h3 className="text-base font-bold text-gray-900 dark:text-white leading-snug">{topic.title}</h3>
        <p className="text-sm text-gray-500 dark:text-white/50 mt-1.5 leading-relaxed flex-1">
          {topic.description}
        </p>
      </div>
    </div>
  );
}

export default function TutorialPage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#0d1520] pb-20 lg:pb-8">
      {/* Header */}
      <div className="bg-white dark:bg-[#111827] border-b border-gray-200/60 dark:border-white/10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          <div className="inline-flex items-center gap-2 bg-cerulean/10 dark:bg-cerulean/20 text-cerulean text-xs font-semibold uppercase tracking-widest px-3 py-1.5 rounded-full mb-4">
            Tutorial
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-3">
            Let's Get You Comfortable
          </h1>
          <p className="text-gray-500 dark:text-white/50 max-w-xl mx-auto text-base leading-relaxed">
            A short video for every part of the app. Watch them in order, or just the ones you need — there's no rush.
          </p>
        </div>
      </div>

      {/* Topic grid */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TUTORIAL_TOPICS.map(topic => (
            <TutorialCard key={topic.id} topic={topic} />
          ))}
        </div>

        {/* Footer note */}
        <p className="text-center text-xs text-gray-400 dark:text-white/25 mt-12">
          Still have questions? Visit the <a href="/help/" className="underline hover:text-cerulean">Help Center</a> or reach out — we're happy to help.
        </p>
      </div>
    </div>
  );
}
